(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller(
      "ActuateWashingProgramsController",
      ActuateWashingProgramsController
    );

  /** @ngInject */
  function ActuateWashingProgramsController($scope, $mdDialog, data, $filter) {
    var vm = this;

    init();

    vm.actuate = function () {
      $mdDialog.hide(data);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    function init() {
      data.forEach(function (item) {
        item.value =
          item.reference === "NAME" && item.reference !== "DESCRIPTION"
            ? $filter("removews")(item.value)
            : item.value;
        item.regexCheck =
          item.reference !== "NAME" && item.reference !== "DESCRIPTION"
            ? "^\\d{1,10}(\\.\\d{1,2})?$"
            : null;
      });
      $scope.$on("$destroy", destroy);
      vm.data = data;
    }

    function destroy() {}
  }
})();
